import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 15000,
});

API.interceptors.request.use(cfg => {
  const t = localStorage.getItem('ff_access');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

API.interceptors.response.use(r => r, async err => {
  const orig = err.config;
  if (err.response?.status === 401 && err.response?.data?.code === 'TOKEN_EXPIRED' && !orig._retry) {
    orig._retry = true;
    try {
      const { data } = await axios.post('/api/auth/refresh', { refresh: localStorage.getItem('ff_refresh') });
      localStorage.setItem('ff_access', data.access);
      localStorage.setItem('ff_refresh', data.refresh);
      orig.headers.Authorization = `Bearer ${data.access}`;
      return API(orig);
    } catch { localStorage.clear(); window.location.href = '/login'; }
  }
  return Promise.reject(err);
});

export const authAPI = {
  customerRegister: d => API.post('/auth/customer/register', d),
  customerLogin:    d => API.post('/auth/customer/login', d),
  providerRegister: d => API.post('/auth/provider/register', d),
  providerLogin:    d => API.post('/auth/provider/login', d),
  adminLogin:       d => API.post('/auth/admin/login', d),
  forgotPassword:   d => API.post('/auth/forgot-password', d),
};
export const marketsAPI  = { list: () => API.get('/markets'), rates: () => API.get('/rates') };
export const providersAPI = {
  browse:    p  => API.get('/providers', { params: p }),
  certList:  () => API.get('/certifications'),
  dashboard: () => API.get('/provider/dashboard'),
  stripeOnboard: () => API.post('/provider/stripe-onboard'),
};
export const jobsAPI = {
  create:         d    => API.post('/jobs', d),
  confirmPayment: id   => API.post(`/jobs/${id}/confirm-payment`),
  complete:       (id,d) => API.post(`/jobs/${id}/complete`, d),
  mine:           ()   => API.get('/jobs/mine'),
};
export const reviewsAPI = { submit: d => API.post('/reviews', d) };
export const adminAPI   = {
  providers: p     => API.get('/admin/providers', { params: p }),
  approve:   (id,d) => API.post(`/admin/providers/${id}/approve`, d),
  reject:    (id,d) => API.post(`/admin/providers/${id}/reject`, d),
};
export default API;
